/* eslint-disable */
export default {
  space: ' ',
  do: ',',
  dot: '.',
  setting: 'Settings',
  chart: 'Statistics',
  organization: 'Organization Management',
  allAccount: 'All Accounts',
  allDiseases: 'All Diseases',
  allOrganization: 'All Organizations',
  refresh: 'Refresh',
  username: 'Username',
  remark: 'Remark',
  userType: 'User Type',
  visiontech: 'Visiontech AI',
  polymindf2fTitle: 'PolyMind AI Generated Non-invasive Fundus Fluorescein Angiography',
  EarlyPhase: 'Early Phase',
  MedPhase: 'Medium Phase',
  LatePhase: 'Late Phase',
  Angiography: 'Angiography Video',
  createUser: 'Create User',
  createdOrg: 'Create',
  bindOrganization: 'Affiliated Organization',
  createdAt: 'Created At',
  edit: 'Edit',
  normal: 'Regular User',
  userInfo: 'User Information',
  organization_admin: 'Organization Administrator',
  users: 'Users',
  reoprt: 'Report', // Note: This seems to be a typo, it should probably be 'report'
  actions: 'Actions',
  assistantId: 'Assistant ID',
  signout: 'Sign Out',
  userPassword: 'Password',
  allReport: 'All Reports',
  IDText: 'Please enter ID to search',
  NameText: 'Please enter name to search',
  uploadText: 'Upload Date',
  export: 'Export',
  reportType: 'Report Type',
  copyButton: 'Backup data',
  view: 'View',
  viewReport: 'View Report',
  type: 'Category',
  osnegative: 'Left Eye (Negative)',
  ospositive: 'Left Eye (Positive)',
  osungradable: 'Left Eye (Ungradable)',
  odnegative: 'Right Eye (Negative)',
  odpositive: 'Right Eye (Positive)',
  odungradable: 'Right Eye (Ungradable)',
  totalData: 'Total Screenings',
  negativeData: 'Negative Result Reports',
  positiveData: 'Positive Result Reports',
  halfgradbleData: 'Partially Graded Reports',
  ungradableData: 'Ungradable Reports',
  usableData: 'Efficiency Rate',
  noData: 'No Results',
  positivePersentData: 'Positivity Rate',
  gradeNums: 'Grading Workload',
  chartTotal: 'Statistical Indicators',
  toDay: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisQuarter: 'This Quarter',
  thisYear: 'This Year',
  HistoryTotal: 'Historical Total',
  updatePassword: 'Update Password',
  newPassword: 'New Password',
  confrimPassword: 'Confirm Password',
  ageText: 'The entered age is not within the allowed range for the assessment model (40 to 80 years old), and the result will be N/A (i.e., no result).',
  naodos: 'N/A indicates a result is not available due to a significant difference in the risk scores between the left and right eyes, which is a rare occurrence. However, due to the elevated risk in one fundus photo, it is advisable to consult a doctor for advice and undergo a comprehensive physical examination in time.',
  // admin
  datepicker: 'Specify Range',
  address: 'Address',
  name: 'Name',
  mobile: 'Mobile Number',
  birthday: 'Birthday',
  startDate: 'Start Date',
  to: 'To',
  endDate: 'End Date',
  reportIsExist: 'Report information already exists, please do not resubmit',
  reportIsNone: 'Report does not exist, please check the path',
  idcode: 'ID code',
  chooseGender: 'Please select gender',
  companyName: 'visiontechAI',
  companyName2: 'Global STEM Professorship Scheme',
  adviceTitle: 'Referral recommendations',
  patientId: 'ID',
  adviceText1: 'Positive lesions are detected, a referral to an ophthalmologist or optometrist is recommended.',
  adviceText2: 'Failure to capture or to grade, a referral to an ophthalmologist or optometrist is recommended.',
  adviceText2_1: 'There are no positive manifestations in the gradable results, but a small number of results cannot be graded. If you feel unwell, please see a doctor in time.',
  adviceText3: 'Regular check-ups if necessary.',
  adviceText4: 'This AI grading system report is for reference only. No information in this AI grading system report can replace professional medical advice, diagnosis, or treatment. ',
  remarkTextPolyMind: 'This AI grading system report is for reference only. No information in this AI grading system report can replace professional medical advice, diagnosis, or treatment. ',
  remarkTextVisiontech: 'This AI grading system report is for reference only. No information in this AI grading system report can replace professional medical advice, diagnosis, or treatment. ',
  information: 'Basic Information',
  initing: 'Initializing...',
  findFundusSenor: 'Checking camera and sensor connection...',
  sensorText: 'Connecting to sensor...',
  fundusText: 'Connecting to camera...',
  back: 'Back',
  shutdonw: 'Shut Down',
  submit: 'Submit',
  cancel: 'Cancel',
  password: 'Password',
  title: 'Artificial intelligence fundus camera system',
  title1: 'Eye Disease Screening',
  title2: 'Microvascular Health Screening',
  title3: 'Eye Disease Screening + Microvascular Health Screening',
  startText: 'Please click the button to start screening',
  readme: 'I have read and agree to',
  usage: 'Terms of Use',
  age: 'Age',
  Diseases: 'Diseases',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  inputText: 'Please enter information',
  startBtnText: 'Submit',
  eyeReportTitle: 'A.I. Eye Health Screening Report',
  cvdReportTitle: 'Cardiovascular disease (CVD) risk report',
  endText1: 'Please take your report.',
  endText2: 'You can scan the QR code to send the photographs',
  endText3: ' and the report to your smart-phone.',
  ByeText1: 'The screening is completed',
  ByeText2: 'See you next time',
  GradingText1: 'The photo capturing process is finished',
  GradingText2: 'Your photographs are now under the AI grading process',
  GradingText3: 'Please wait for the generation of your report.',
  createdText: 'Recording Date',
  od: 'Right',
  os: 'Left',
  ungradable: 'Ungradable',
  Gradable: 'Gradable',
  grading: 'Grading',
  dr: 'Diabetic Retinopathy',
  amd: 'Age-related Macular Degeneration',
  cataract: 'Severe Cataract',
  glaucoma: 'Glaucoma',
  drnp: 'Diabetic Retinopathy',
  gradeFail: 'Ungradable',
  No_DR: 'No DR lesions detected',
  Mild_NPDR: 'Mild NPDR',
  Moderate_NPDR: 'Moderate NPDR',
  Severe_NPDR: 'Severe NPDR',
  Proliferative_DR: 'PDR ',
  medium_risk: 'Medium risk',
  high_risk: 'High risk',
  low_risk: 'Low risk',
  negative: 'Negative',
  lowprobability: 'Low probability',
  Possible: 'Possible',
  positive: 'Positive',
  cpositive: 'Positive',
  cvdResult: 'Evaluation Result',
  cvdPoint: 'Retina-based predicted CVD risk score',
  early_or_intermediate: 'Early or intermediate',
  other: 'Other Diseases',
  otherText: '*This system is capable of assisting in the detection of 59 common eye diseases and 61 rare eye diseases. The results are for reference only and are not a substitute for professional medical diagnosis and treatment.',
  late_dry: 'Late dry AMD',
  late_wet: 'late wet AMD',
  cvdInfoTitle: 'Fundus images and evaluation results',
  cvdInfoText1: 'These images include one original photo taken by the retinal camera, and a retinal vessel profile image, vessel calibre measurement and vessel tortuosity maps, generated automatically by the artificial intelligence system.',
  cvdInfoText2: ' A low cardiovascular disease risk score is recommended to be reviewed by your healthcare professional every two years, unless otherwise specified by your healthcare professional.',
  cvdInfoText3: 'A moderate cardiovascular disease risk score is recommended to be reviewed by your healthcare professional every 6-12 months, unless otherwise specified by your healthcare professional.',
  cvdInfoText4: 'A high cardiovascular disease risk score is recommended to be reviewed by your healthcare professional every 3 months, unless otherwise specified by your healthcare professional.',
  cvdInfoText4_1: 'Your retina-based predicted cardiovascular disease risk score is',
  cvdInfoText4_2: ',indicating the 10-year risk (in percentage) of developing cardiovascular events for an individual, with <10% as low risk, 10-20% as moderate risk and ≥20% as high risk. This is generated by an artificial intelligence system and is solely based on retinal photos of the vessel in your eyes.',
  remarkTitle: 'Disclaimer',
  remarkText3: 'This report is produced by the artificial intelligence system of the OptiScreen. This report is not a substitute for professional advice or treatment and is for clinical expert reference only.',
  remarkText2: 'This report is produced by the artificial intelligence system of the Global STEM Professorship Scheme. This report is not a substitute for professional advice or treatment and is for clinical expert reference only.',
  remarkText: 'This AI system is intended to provide an automated analysis of the retinal blood vessels, for use as an indicator of the overall heart & brain, and blood vessel health of the body. It is not intended to make any clinical diagnoses or replace the clinical judgement of a medical practitioner. The output of this report should only be reviewed in consideration of other data points by qualified clinicians.',
  noPhoto: 'Capture failed or not captured',
  reportInfoTitle: 'Overview of Report Results',
  noNormalDisease: 'No obvious common eye diseases found',
  noOtherDisease: 'No obvious diseases found.',
  normalDiseases: 'Common eye diseases refer to conditions that require referral, such as diabetic retinopathy, glaucomatous optic neuropathy, and severe cataracts.',
  normalDiseases2: 'Common eye diseases refer to conditions that require referral, such as diabetic retinopathy, age-related macular degeneration and glaucomatous optic neuropathy.',
  remarkText4: 'The cardiovascular disease risk score is generated by the data from analysis of the fundus photos, age and gender using the result of the latest scientific research achievement and artificial intelligence technology. This report is provided by the artificial intelligence systems of OptiScreen and PolyMind AI.',
  Recommendations: 'Comprehensive Recommendations',
  imageQuality: 'Fundus Image Quality Analysis',
  diseaseD: 'Eye Disease Risk Assessment',
  cvdD: 'Cardiovascular Health Risk Assessment',
  shootingSuccess: 'Photo capture successful',
  shootingFail: 'Photo capture unsuccessful',
  success: 'successful',
  fail: 'unsuccessful',
  shootingFailText: 'Unable to capture the retinal image, it is recommended to retake the photo.',
  Evaluate_grading_results: 'Evaluation Grading Results',
  poorQuality: 'Poor Image Quality',
  interpretation_result: 'Grading Result Interpretation',
  poorQuality_in: 'Poor Image Quality: Indicates that your fundus image may not meet the grading standards due to a [small pupil].',
  cvd_result_title: 'Cardiovascular Health Risk Assessment Results',
  cvd_dcm_result_title: 'Vessel Segmentation And Assessment Results',
  retinal_arteriovenous_ratio: 'Retinal Arteriovenous Ratio',
  standard_value: 'Standard Value',
  normal_standard: 'Your retinal arteriovenous ratio is within the normal range.',
  unnormal_standard: 'The retinal arteriovenous ratio is less than standard value.',
  standard_text: 'The retinal arteriovenous ratio refers to the ratio of retinal arteries to veins. Under normal circumstances, the diameter ratio of retinal arteries to veins is 2:3 (0.67). If abnormalities occur, which may be caused by vasoconstriction, hypertension, etc., can increase the risk of cardiovascular diseases.  ',
  cvd_age: 'Retinal Age',
  your_cvd_age: 'Your retinal age is',
  smaller_age: 'Your retinal age is younger than your actual age, indicating a lower level of biological aging compared to peers.',
  older_age: 'Your retinal age is greater than your actual age. It means you are biologically aging more than your peers. ',
  remarkText5: 'This report cannot replace professional advice or treatment and is for reference by clinical experts only.',
  odeye: 'Right eye',
  oseye: 'Left eye',
  glaucomaH2: 'Glaucoma',
  DRText: 'Suspected retinopathy',
  HE: 'Hemorrhage',
  EX: 'Exudates',
  CWS: 'Cotton wool spots',
  MA: 'Microaneurysm',
  fundus: 'Fundus quality',
  // AnR
  public_Reject: 'Unable to capture the retinal image, it is recommended to retake the photo.',
  public_Usable: '',
  public_Good: '',
  other_negative_recommendations: 'Regular comprehensive eye  examination is recommended.',
other_assessment: {
    "and neuroretinitis": "Neuroretinitis",
    "aneurysms": "Retinal arterial macroaneurysm",
    "vasculitis": "Vasculitis (ocular)",
    "behcet disease": "Behçet disease",
    "best vitelliform macular dystrophy": "Best vitelliform macular dystrophy",
    "bietti's crystalline dystrophy": "Bietti's crystalline dystrophy",
    "cmv retinitis": "CMV retinitis (cytomegalovirus retinitis)",
    "coat's disease": "Coats disease",
    "dalen–fuchs nodules": "Dalen–Fuchs nodules",
    "eales' disease": "Eales' disease",
    "hiv retinopathy": "HIV retinopathy",
    "lyme disease": "Lyme disease (ocular involvement)",
    "stargardt disease": "Stargardt disease",
    "terson syndrome": "Terson syndrome",
    "vogt-koyanagi-harada disease": "Vogt–Koyanagi–Harada disease (VKH)",
    "von hippel-lindau syndrome": "Von Hippel–Lindau syndrome (VHL)",
    "x-linked juvenile retinoschisis ": "X-linked juvenile retinoschisis",
    "abnormal": "Abnormal (non-specific)",
    "active toxoplasmosis": "Active ocular toxoplasmosis",
    "acute posterior multifocal placoid pigment epitheliopathy": "Acute posterior multifocal placoid pigment epitheliopathy (APMPPE)",
    "acute retinal necrosis": "Acute retinal necrosis (ARN)",
    "adult-onset vitelliform macular dystrophy": "Adult-onset vitelliform macular dystrophy",
    "age-related macular degeneration": "Age-related macular degeneration (AMD)",
    "albinism": "Albinism (ocular involvement)",
    "aneurysm": "Retinal arterial macroaneurysm",
    "angioid streak": "Angioid streaks",
    "anterior ischemic optic neuropathy": "Anterior ischemic optic neuropathy (AION)",
    "arterial-venous nicking": "Arteriovenous (AV) nicking",
    "arteriosclerosis": "Arteriosclerosis (retinal)",
    "arteriovenous malformation": "Arteriovenous malformation (AVM)",
    "arteriovenous shunts": "Arteriovenous shunts / fistula",
    "asteroid bodies": "Asteroid hyalosis",
    "asteroid hyalosis": "Asteroid hyalosis",
    "atrophy": "Atrophy (unspecified)",
    "birdshot retinochoroidopathy": "Birdshot chorioretinopathy",
    "bone spicules pigmentation": "Bone-spicule pigmentation (suggestive of retinitis pigmentosa)",
    "branch retinal artery occlusion": "Branch retinal artery occlusion (BRAO)",
    "branch retinal vein occlusion": "Branch retinal vein occlusion (BRVO)",
    "branching vascular network": "Branching vascular network (BVN, PCV feature)",
    "bull's eye maculopathy": "Bull's-eye maculopathy",
    "candida endophthalmitis": "Candida endophthalmitis",
    "central areolar choroidal dystrophy": "Central areolar choroidal dystrophy",
    "central retinal artery occlusion": "Central retinal artery occlusion (CRAO)",
    "central retinal vein occlusion": "Central retinal vein occlusion (CRVO)",
    "central serous chorioretinopathy": "Central serous chorioretinopathy (CSCR)",
    "chloroquine toxicity": "Chloroquine / hydroxychloroquine toxicity (maculopathy)",
    "chorioretinal atrophy": "Chorioretinal atrophy",
    "chorioretinal dystrophy": "Chorioretinal dystrophy",
    "choroidal detachment": "Choroidal detachment",
    "choroidal folds": "Choroidal folds",
    "choroidal hemangioma": "Choroidal hemangioma",
    "choroidal mass": "Choroidal mass (unspecified)",
    "choroidal melanoma": "Choroidal melanoma",
    "choroidal metastasis": "Choroidal metastasis",
    "choroidal neoplasm": "Choroidal neoplasm",
    "choroidal neovascularization": "Choroidal neovascularization (CNV)",
    "choroidal nevus": "Choroidal nevus",
    "choroidal osteoma": "Choroidal osteoma",
    "choroidal rupture": "Choroidal rupture",
    "choroiditis": "Choroiditis",
    "chronic central retinal vein occlusion": "Chronic central retinal vein occlusion",
    "chronic central serous chorioretinopathy": "Chronic central serous chorioretinopathy",
    "chronic retinal vein occlusion": "Chronic retinal vein occlusion",
    "chronic toxoplasmosis": "Chronic ocular toxoplasmosis",
    "cilioretinal artery occlusion": "Cilioretinal artery occlusion",
    "combined hamartoma": "Combined hamartoma of retina and RPE",
    "commotio retinae": "Commotio retinae",
    "cone dystrophy": "Cone dystrophy",
    "cone-rod dystrophy": "Cone-rod dystrophy",
    "congenital anomaly": "Congenital anomaly (unspecified)",
    "congenital chorioretinal coloboma": "Congenital chorioretinal coloboma",
    "congenital chorioretinopathy": "Congenital chorioretinopathy",
    "congenital choroideremia": "Choroideremia",
    "congenital coloboma": "Congenital coloboma",
    "congenital macular coloboma": "Congenital macular coloboma",
    "congenital optic disc coloboma": "Congenital optic disc coloboma",
    "congenital stationary night blindness": "Congenital stationary night blindness (CSNB)",
    "congential optic disc abnormalities": "Congenital optic disc abnormalities",
    "cotton-wool spot": "Cotton-wool spot",
    "cystoid macular edema": "Cystoid macular edema (CME)",
    "detachment": "Retinal detachment (unspecified)",
    "diabetic retinopathy": "Diabetic retinopathy (DR)",
    "drusen": "Drusen",
    "dry age-related macular degeneration": "Dry AMD",
    "edema": "Edema (unspecified)",
    "endophthalmitis": "Endophthalmitis",
    "epiretinal membrane": "Epiretinal membrane (ERM)",
    "exudate": "Exudate",
    "exudative retinal detachment": "Exudative retinal detachment",
    "familial exudative vitreoretinopathy": "Familial exudative vitreoretinopathy (FEVR)",
    "fibroproliferation": "Fibroproliferation (PVR-related)",
    "fibrovascular retinal pigment epithelial detachment": "Fibrovascular RPE detachment",
    "fleck": "Fleck lesion (unspecified)",
    "gas-tamponade": "Gas tamponade",
    "geographic atrophy": "Geographic atrophy (GA)",
    "glaucoma": "Glaucoma",
    "gyrate atrophy": "Gyrate atrophy",
    "hamartoma": "Hamartoma (unspecified)",
    "hard drusen": "Hard drusen",
    "hemorrhage": "Hemorrhage (ocular)",
    "high myopia": "High myopia",
    "hyperpigmentation": "Hyperpigmentation (ocular)",
    "hyperplastic retinal pigment epithelium": "Hyperplastic RPE",
    "hypertensive retinopathy": "Hypertensive retinopathy",
    "hypertrophy of the rpe": "RPE hypertrophy",
    "hypopigmentation": "Hypopigmentation (ocular)",
    "idiopathic retinitis": "Idiopathic retinitis",
    "infarction": "Infarction (retinal/optic)",
    "intermediate uveitis": "Intermediate uveitis",
    "intraocular foreign body": "Intraocular foreign body",
    "intraretinal hemorrhage": "Intraretinal hemorrhage",
    "intraretinal microvascular abnormalities": "Intraretinal microvascular abnormalities (IRMA)",
    "ischemia": "Ischemia (retinal)",
    "ischemic branch retinal vein occlusion": "Ischemic BRVO",
    "ischemic central retinal vein occlusion": "Ischemic CRVO",
    "ischemic optic neuropathy": "Ischemic optic neuropathy",
    "lacquer crack": "Lacquer crack (myopic)",
    "lamellar macular hole": "Lamellar macular hole",
    "large cup": "Large cup-to-disc ratio",
    "laser spots": "Laser photocoagulation spots/scars",
    "late dry age-related macular degeneration": "Late dry AMD",
    "lattice degeneration": "Lattice degeneration",
    "leukemic retinopathy": "Leukemic retinopathy",
    "lipemia retinalis": "Lipemia retinalis",
    "lymphoma": "Ocular lymphoma",
    "macroaneurysm": "Retinal arterial macroaneurysm",
    "macula off retinal detachment": "Macula-off retinal detachment",
    "macular atrophy": "Macular atrophy",
    "macular dystrophy": "Macular dystrophy",
    "macular ectopia": "Macular ectopia",
    "macular edema": "Macular edema",
    "macular hemorrhage": "Macular hemorrhage",
    "macular hole": "Macular hole",
    "macular telangiectasia": "Macular telangiectasia (MacTel)",
    "maculopathy": "Maculopathy (unspecified)",
    "mass": "Mass (intraocular/ocular)",
    "media opacity": "Media opacity (cornea/lens/vitreous)",
    "melanocytoma": "Melanocytoma (optic disc melanocytoma)",
    "melanoma": "Melanoma (uveal/choroidal)",
    "microaneurysm": "Microaneurysm",
    "mild nonproliferative diabetic retinopathy": "Mild NPDR",
    "moderate nonproliferative diabetic retinopathy": "Moderate NPDR",
    "morning glory syndrome": "Morning glory syndrome",
    "multifocal choroiditis": "Multifocal choroiditis",
    "multiple evanescent white dot syndrome": "Multiple evanescent white dot syndrome (MEWDS)",
    "multiple myeloma": "Multiple myeloma (ocular involvement)",
    "myelinated retinal nerve fiber layer": "Myelinated retinal nerve fibers",
    "myopia": "Myopia",
    "neoplasm": "Neoplasm (unspecified)",
    "neuroepithelial detachment": "Neuroepithelial detachment",
    "neurofibromatosis": "Neurofibromatosis (ocular)",
    "neuroretinitis": "Neuroretinitis",
    "neuroretinopathy": "Neuroretinopathy",
    "nonperfusion area": "Non-perfusion area (retina)",
    "nonproliferative diabetic retinopathy": "Nonproliferative diabetic retinopathy (NPDR)",
    "normal": "Normal",
    "normal": "Normal",
    "ocular candidiasis": "Ocular candidiasis",
    "ocular histoplasmosis syndrome": "Ocular histoplasmosis syndrome (OHS)",
    "ocular ischemic syndrome": "Ocular ischemic syndrome",
    "ocular parasitosis": "Ocular parasitosis",
    "ocular tuberculosis": "Ocular tuberculosis",
    "old retinal vein occlusion": "Old (chronic/resolved) retinal vein occlusion",
    "optic atrophy": "Optic atrophy",
    "optic disc drusen": "Optic disc drusen",
    "optic disc edema": "Optic disc edema",
    "optic disc melanocytoma": "Optic disc melanocytoma",
    "optic disc neovascularization": "Optic disc neovascularization",
    "optic disc pallor": "Optic disc pallor",
    "optic disc pit": "Optic disc pit",
    "optic nerve hypoplasia": "Optic nerve hypoplasia",
    "optic neuritis": "Optic neuritis",
    "panuveitis": "Panuveitis",
    "papillitis": "Papillitis",
    "pars plana vitrectomy": "Pars plana vitrectomy (PPV)",
    "patchy chorioretinal atrophy": "Patchy chorioretinal atrophy",
    "pathologic myopia": "Pathologic myopia",
    "pattern dystrophy": "Pattern dystrophy",
    "perifoveal telangiectasia": "Perifoveal telangiectasia",
    "peripapillary atrophy": "Peripapillary atrophy",
    "pigmentary change": "Pigmentary change",
    "plaquenil toxicity": "Chloroquine / hydroxychloroquine toxicity (Plaquenil)",
    "polypoidal choroidal vasculopathy": "Polypoidal choroidal vasculopathy (PCV)",
    "polypoidal vascular abnormality ": "Polypoidal vascular abnormality (PCV)",
    "poor quality": "Poor image quality",
    "posterior uveitis": "Posterior uveitis",
    "posterior vitreous detachment": "Posterior vitreous detachment (PVD)",
    "preretinal hemorrhage": "Preretinal hemorrhage",
    "presumed ocular histoplasmosis syndrome": "Presumed ocular histoplasmosis syndrome (POHS)",
    "proliferative diabetic retinopathy": "Proliferative diabetic retinopathy (PDR)",
    "proliferative vitreoretinopathy": "Proliferative vitreoretinopathy (PVR)",
    "pseudopapilledema": "Pseudopapilledema",
    "pseudoxanthoma elasticum": "Pseudoxanthoma elasticum (PXE)",
    "punctate inner choroidopathy": "Punctate inner choroidopathy (PIC)",
    "radiation retinopathy": "Radiation retinopathy",
    "red small dots": "Small red dots (non-specific retinal finding)",
    "referable diabetic retinopathy": "Referable diabetic retinopathy",
    "retinal angiomatous proliferation": "Retinal angiomatous proliferation (RAP)",
    "retinal arterial macroaneurysm": "Retinal arterial macroaneurysm",
    "retinal artery occlusion": "Retinal artery occlusion",
    "retinal capillary hemangioblastoma": "Retinal capillary hemangioblastoma (RCH)",
    "retinal cavernous hemangioma": "Retinal cavernous hemangioma",
    "retinal collateral": "Retinal collateral vessels",
    "retinal detachment": "Retinal detachment (RD)",
    "retinal dystrophy": "Retinal dystrophy (unspecified)",
    "retinal neovascularization": "Retinal neovascularization",
    "retinal pigment epithelial detachment": "Retinal pigment epithelial detachment (PED)",
    "retinal pigment epithelial tears": "Retinal pigment epithelial tears",
    "retinal pigment epithelium hamartoma": "RPE hamartoma",
    "retinal tear": "Retinal tear",
    "retinal telangiectasia": "Retinal telangiectasia",
    "retinal vein occlusion": "Retinal vein occlusion (RVO)",
    "retinal vessel attenuation": "Retinal vessel attenuation",
    "retinitis": "Retinitis",
    "retinitis pigmentosa": "Retinitis pigmentosa (RP)",
    "retinoblastoma": "Retinoblastoma",
    "retinopathy of prematurity": "Retinopathy of prematurity (ROP)",
    "retinoschisis": "Retinoschisis",
    "rhegmatogenous retinal detachment": "Rhegmatogenous retinal detachment",
    "roth spots": "Roth spots",
    "sarcoidosis": "Sarcoidosis (ocular)",
    "scar": "Scar (retinal/ocular)",
    "scleral band": "Scleral band / scleral buckle",
    "serous pigment epithelial detachment": "Serous pigment epithelial detachment (serous PED)",
    "serous retinal detachment": "Serous retinal detachment",
    "serpiginous choroiditis": "Serpiginous choroiditis",
    "severe nonproliferative diabetic retinopathy": "Severe NPDR",
    "sickle cell retinopathy": "Sickle cell retinopathy",
    "silicone-oil-tamponade": "Silicone oil tamponade",
    "solar retinopathy": "Solar retinopathy",
    "staphyloma": "Staphyloma (posterior staphyloma)",
    "subhyaloid hemorrhage": "Subhyaloid hemorrhage",
    "submacular hemorrhage": "Submacular hemorrhage",
    "subretinal exudate": "Subretinal exudate",
    "subretinal fibrosis": "Subretinal fibrosis",
    "subretinal hemorrhage": "Subretinal hemorrhage",
    "sympathetic ophthalmia": "Sympathetic ophthalmia",
    "syphilis": "Syphilis (ocular)",
    "systemic lupus erythematosus vasculitis": "SLE-associated vasculitis",
    "tessellation": "Tessellated fundus (tessellation)",
    "tortuous": "Tortuous vessels",
    "toxocariasis": "Toxocariasis (Toxocara ocular infection)",
    "toxoplasmosis": "Toxoplasmosis (ocular)",
    "traction": "Traction (unspecified)",
    "tractional retinal detachment": "Tractional retinal detachment",
    "tuberculosis": "Tuberculosis (ocular)",
    "uveitis": "Uveitis",
    "valsalva retinopathy": "Valsalva retinopathy",
    "vascular hamartoma": "Vascular hamartoma",
    "vascular sheath": "Vascular sheathing / vascular sheath",
    "vasculitis": "Vasculitis (ocular)",
    "venous loop": "Venous loop",
    "viral retinitis": "Viral retinitis (e.g., HSV/VZV/CMV)",
    "vitelliform macular dystrophy": "Vitelliform macular dystrophy",
    "vitreomacular traction syndrome": "Vitreomacular traction syndrome",
    "vitreous degeneration": "Vitreous degeneration",
    "vitreous hemorrhage": "Vitreous hemorrhage",
    "vitreous opacity": "Vitreous opacity / floaters",
    "vitritis": "Vitritis",
    "wet age-related macular degeneration": "Wet AMD",
    "white dot syndrome": "White dot syndrome (group of entities)"
  },
  // drnp
  drnp_negative_assessment: 'No obvious diabetic retinopathy was found.',
  drnp_negative_recommendations: 'Regular comprehensive eye  examination is recommended.',
  drnp_positive_assessment: 'Highly suspected diabetic retinopathy, please promptly consult professionals for further investigation. ',
  drnp_positive_recommendations: 'Diabetic retinopathy-like abnormalities were found on retina, which may be caused by diabetes. Please consult an optometrist or ophthalmologist for further examination and treatment promptly. Attention should be paid to control blood sugar level.  It is recommended to have a balanced diet, exercise regularly. Vision loss or even blindness could be resulted from delayed diagnosis and treatment.',
  drnp_ungradable_assessment: 'The image quality is poor and the analysis cannot be completed.',
  drnp_ungradable_recommendations: 'It is recommended to retake the image or go to a professional eyecare centre for detailed examination.',

  // glaucoma
  glaucoma_negative_assessment: 'No obvious glaucomatous optic neuropathy was found.',
  glaucoma_positive_assessment: 'The risk of glaucomatous optic neuropathy is high. Please consult professionals for further investigation.',
  glaucoma_negative_recommendations: 'Regular comprehensive eye examination is recommended.',
  glaucoma_positive_recommendations: 'There are glaucomatous optic neuropathy-like abnormalities which may likely caused by optic nerve damage. It is recommended to consult an optometrist or ophthalmologist for further examination and treatment. Visual impairment, such as narrowing of the visual field, could be resulted from delayed diagnosis and treatment.',
  glaucoma_low_risk_assessment: 'No obvious glaucomatous optic neuropathy was found.',
  glaucoma_low_risk_recommendations: 'Regular comprehensive eye examination is recommended.',
  glaucoma_medium_risk_assessment: 'The risk of glaucomatous optic neuropathy is moderate. ',
  glaucoma_medium_risk_recommendations: 'There are glaucomatous optic neuropathy-like abnormalities. It may be caused by damaged  optic nerve or personal growth differences. It is recommended to consult an optometrist or ophthalmologist for further examination and treatment. Visual impairment, such as narrowing of the visual field, could be resulted from delayed diagnosis and treatment.',
  glaucoma_high_risk_assessment: 'The risk of glaucomatous optic neuropathy is high. Please consult professionals for further investigation.',
  glaucoma_high_risk_recommendations: 'There are glaucomatous optic neuropathy-like abnormalities which may likely caused by optic nerve damage. It is recommended to consult an optometrist or ophthalmologist for further examination and treatment. Visual impairment, such as narrowing of the visual field, could be resulted from delayed diagnosis and treatment.',
  glaucoma_ungradable_assessment: 'The image quality is not up to grading standard and the analysis cannot be completed.',
  glaucoma_ungradable_recommendations: 'It is recommended to retake the image or go to a professional eyecare centre for detailed examination.',

  // cataract
  cataract_negative_assessment: 'No obvious severe cataract changes were found.',
  cataract_negative_recommendations: 'Regular comprehensive eye examination is recommended.',
  cataract_positive_assessment: 'Severe cataract may exist and affect vision. ',
  cataract_positive_recommendations: 'Suspected severe cataract is found from the  photo, which may be caused by lens opacity or other refractive medium opacity. It is recommended to consult an optometrist or ophthalmologist for further examination and treatment. Vision loss could be resulted from delayed diagnosis and treatment.',
  cataract_ungradable_assessment: 'The image quality is not up to grading standard and the analysis cannot be completed.',
  cataract_ungradable_recommendations: 'It is recommended to retake the image or go to a professional eyecare centre for detailed examination.',

  // amd
  amd_negative_assessment: 'No obvious Age-related macular degeneration changes were found.',
  amd_negative_recommendations: 'Regular comprehensive eye examination is recommended.',
  amd_positive_assessment: 'Age-related macular degeneration may exist and affect vision. ',
  amd_positive_recommendations: 'Suspected Age-related macular degeneration  is found from the  photo, which may be caused by lens opacity or other refractive medium opacity. It is recommended to consult an optometrist or ophthalmologist for further examination and treatment. Vision loss could be resulted from delayed diagnosis and treatment.',
  amd_ungradable_assessment: 'The image quality is not up to grading standard and the analysis cannot be completed.',
  amd_ungradable_recommendations: 'It is recommended to retake the image or go to a professional eyecare centre for detailed examination.',
  // cvd
  cvd_low_risk_recommendations: 'Low-risk individuals are recommended to undergo cardiovascular examinations once a year.',
  cvd_medium_risk_recommendations: 'Moderate-risk individuals are recommended to pay attention to their cardiovascular health and to consult doctors when necessary. ',
  cvd_high_risk_recommendations: 'High-risk individuals are advised to seek medical advice promptly and take precautions for cardiovascular health.',
  cvd_NA_40_80_recommendations: 'This artificial intelligence system applies to age between 40 and 80 years old. If the age is outside this range, N/A will be displayed.',
  cvd_NA_recommendations: 'When there is a large discrepancy between the risk level obtained from the left and right eye images. N/A will be displayed and  result will not be shown. This is a rare case. However, due to the risk level obtained from one eye is higher, it is recommended to consult a doctor and follow up on the relevant risks.',
  cvd_ungradable_assessment: 'The image quality is not up to grading standard and the analysis cannot be completed.',
  cvd_ungradable_recommendations: 'It is recommended to retake the image or go to a professional eyecare centre for detailed examination.',

  // total recommend
  all_negative_recommendations: 'Regular comprehensive eye examination is recommended.',
  all_positive_recommendations: 'It is recommended to consult an optometrist or ophthalmologist for advice regarding the screening result. ',
  all_positive_recommendations_2: 'It is recommended to maintain a balanced diet, control blood sugar level and blood pressure, and exercise regularly. You should also uphold healthy lifestyle habits and closely monitor your health condition. Regular follow-up examinations of the fundus and cardiovascular health risks are advised.',
  half_ungradable_recommendations: 'It is recommended to maintain a balanced diet and do regular exercise. To uphold healthy living habits, monitor personal health closely, such as  blood sugar level and blood pressure .  and consider regular assessment of the fundus and cardiovascular health risks.',
  all_ungadable_recommendations: 'The image quality is not up to grading standard and the system cannot complete the analysis. Possible reasons include, but are not limited to, small pupil size, unable to maintain fixation, blinked during shooting, etc. It is recommended to retake the image or go to a professional eyecare centre for detailed examination.',
  half_ungradable_text: 'The image quality is not up to grading standard and the system cannot complete the analysis. Possible reasons include, but are not limited to, small pupil size, unable to maintain fixation, blinked during shooting, etc. It is recommended to retake the image or go to a professional eyecare centre for detailed examination.'
}
